import { render } from "./StatsItem.vue?vue&type=template&id=508c531d&scoped=true"
import script from "./StatsItem.vue?vue&type=script&lang=js"
export * from "./StatsItem.vue?vue&type=script&lang=js"

import "./StatsItem.vue?vue&type=style&index=0&id=508c531d&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508c531d"]])

export default __exports__